/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';

export default Component.extend({
  isFocussed: false,
  disabled: false,
  classNameBindings: ['isFocussed:is-focussed'],

  focusIn() {
    if (!this.disabled) {
      this.set('isFocussed', true);
    }
  },

  focusOut() {
    if (!this.disabled) {
      this.set('isFocussed', false);
    }
  },
});
